<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-4">
                    <b-card-title>
                        {{ $t('omt.gui.menu.label.goods-receipt-create') }}
                    </b-card-title>

                    <b-form @submit.prevent="handleFormSubmit" class="mt-4">
                        <b-row>
                            <b-col sm="2">
                                <label>Leverancier</label><br/>
                            </b-col>
                            <b-col sm="10">
                                <template v-if="isLoadingAvailableLocations">
                                    <span>
                                        Een moment geduld, de lijst met leveranciers wordt opgehaald.
                                    </span>
                                    <FontAwesomeIcon icon="spinner" spin class="ml-1" />
                                </template>

                                <template v-else>
                                    <b-form-select v-model="form.supplier_identifier"
                                                :options="availableLocations"
                                                size="sm"
                                    />
                                </template>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2">
                            <b-col sm="2">
                                <label>Referentie</label><br/>
                            </b-col>
                            <b-col sm="10">
                                <b-form-input type="text" v-model="form.identifier" size="sm" />
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <OmniButtonCollection alignment="end" class="mt-4">
                                    <OmniButton :to="{ name: 'GoodsReceiptIndex'}">{{ $t('omt.gui.general.action.cancel') }}</OmniButton>
                                    <OmniButton type="submit" :disabled="isCreatingGoodsReceipt || !isFormValid">
                                        {{ $t('omt.gui.menu.label.goods-receipt-create') }}
                                        <FontAwesomeIcon v-if="isCreatingGoodsReceipt" icon="spinner" class="ml-1" spin />
                                    </OmniButton>
                                </OmniButtonCollection>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
const AUTO_CREATE_RANDOM_IDENTIFIER = false;

export default {
    name: 'GoodsReceiptCreate',
    props: {
        locationTypeIdentifier: {
            type: String,
            required: true,
            default: '',
        },
        locationIdentifier: {
            type: String,
            required: true,
            default: '',
        },
    },
    data() {
        return {
            isLoadingAvailableLocations: false,
            isCreatingGoodsReceipt: false,
            form: {
                identifier: '',
                supplier_identifier: '',
            },
            availableLocations: [
                { value: '', text: 'Kies een locatie...', disabled: true },
            ]
        }
    },
    methods: {
        /**
         * Fetches available locations from the API and formats them for use in a b-form-select.
         * 
         * @param {Object} params - The parameters for the function.
         * @param {String} params.locationTypeIdentifier - The type of location to filter.
         */
        fetchAvailableLocations({ locationTypeIdentifier }) {
            this.isLoadingAvailableLocations = true;

            const endpoint = `/api/rest/locations`;
            this.$http.get(endpoint)
                .then(response => {
                    const { data } = response;

                    const availableLocations = data.reduce((accumulator, location) =>
                        {
                            if (location.location_type.identifier === locationTypeIdentifier) {
                                accumulator.push({
                                    value: location.identifier,
                                    text: `${location.display_name} (${location.identifier})`
                                });
                            }
                            return accumulator;
                        },
                        [
                            { value: '', text: 'Kies een leverancier...', disabled: true }
                        ]
                    );

                    this.availableLocations = [...availableLocations];
                })
                .catch(error => {
                    this.$alert('Er is iets misgegaan bij het ophalen van de beschikbare leveranciers.', 'danger');
                    console.error(`GoodsReceiptCreate, fetchAvailableLocations({ ...params }): ${error}`);
                })
                .finally(() => {
                    this.isLoadingAvailableLocations = false;
                })
        },
        createGoodsReceipt({ identifier, supplier_identifier }) {
            this.isCreatingGoodsReceipt = true;

            const endpoint = `/api/rest/locations/${this.locationTypeIdentifier}/${this.locationIdentifier}/goods-receipts`;

            const payload = {
                identifier,
                supplier_identifier
            };
            
            this.$http.post(endpoint, payload)
                .then((response) => {
                    if (response.status === 201) {
                        this.$alert('Goederenontvangst succesvol aangemaakt');
                        this.$router.push(
                            {
                                name: 'GoodsReceiptView',
                                params: {
                                    goodsReceiptIdentifier: identifier,
                                }
                            }
                        );
                    }
                })
                .catch(error => {
                    this.$alert('Er is iets misgegaan bij het aanmaken van de goederenontvangst.', 'danger', true);
                    console.error(`GoodsReceiptCreate, createGoodsReceipt({ ...params }): ${error}`);
                })
                .finally(() => {
                    this.isCreatingGoodsReceipt = false;
                });
        },
        handleFormSubmit() {
            this.createGoodsReceipt(this.form);
        },
        generateRandomIdentifier() {
            return parseInt(crypto.randomUUID().split('-').pop(), 16).toString(36).toUpperCase();
        },
    },
    computed: {
        isFormValid() {
            return this.form.identifier.trim()          !== '' &&
                   this.form.supplier_identifier.trim() !== '' ;
        }
    },
    created() {
        if (AUTO_CREATE_RANDOM_IDENTIFIER === true) {
            this.form['identifier'] = this.generateRandomIdentifier();
        }
    },
    mounted() {
        this.fetchAvailableLocations({ locationTypeIdentifier: 'vendor' });
    },
    watch: {
        locationIdentifier(newVal) {
            this.form.supplier_identifier = newVal;
        }
    },
}
</script>
